var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crm-loading"},[_c('div',{staticClass:"crm-loading-info"},[_c('p',[_vm._t("default")],2),_c('preloader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }